// extracted by mini-css-extract-plugin
export var banner = "_1p-0";
export var icon = "_1p-1";
export var message = "_1p-2";